<div class="center-xy" [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
    *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light"  data-testid="constant-temp-control">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <zone-icon [name]="zones.selectedZone.description.styleIcon" [size]="45"></zone-icon>
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                {{ zones.getZoneName(zones.selectedZone) }}
            </p>
        </div>

        <div class="zone-control__content">
            <div class="zone-control__control text-align-center">
                <p class="zone-control__control-title font-22 font-bold bg-settings bg-settings--zone">
                    {{ subtitle(1660) }}
                </p>
                <div class="control__range">
                    <div class="control__value color-basic font-55" data-testid="set-temperature">
                        {{ (zones.selectedZone['mode'].setTemperature < 50 ? 200 : zones.selectedZone['mode'].setTemperature) | format:7 }}
                    </div>
                    <div class="control__min color-basic font-14 font-bold">
                        <p>
                            {{ subtitle(395) }}{{ 5 | format:6 }}
                        </p>
                    </div>
                    <div class="control__max color-basic font-14 font-bold">
                        <p>
                            {{ subtitle(1064) }}{{ 35 | format:6 }}
                        </p>
                    </div>
                    <input class="control__input-range cursor-pointer"
                           data-testid="set-temperature-slider"
                           type="range"
                           step="1"
                           min="50"
                           max="350"
                           value="{{ zones.selectedZone['mode'].setTemperature }}"
                           [(ngModel)]="zones.selectedZone['mode'].setTemperature" />
                    <div class="control__remove cursor-pointer">
                        <hold-wrapper (onAction)="zones.selectedZone['mode'].setTemperature = zones.minusVal(zones.selectedZone['mode'].setTemperature)">
                            <img ngSrc="/assets/img/icons/minus.svg"
                                 data-testid="minus-icon"
                                 width="40" height="40" alt="" />
                        </hold-wrapper>
                    </div>
                    <div class="control__add cursor-pointer">
                        <hold-wrapper (onAction)="zones.selectedZone['mode'].setTemperature = zones.plusVal(zones.selectedZone['mode'].setTemperature)">
                            <img ngSrc="/assets/img/icons/plus.svg"
                                 data-testid="plus-icon"
                                 width="40" height="40" alt="" />
                        </hold-wrapper>
                    </div>
                </div>
            </div>

            <div class="control__group-btn">
                <button class="control__button bg-default bg-default__button"
                    (click)="zones.goBack()">
                    <img class="control__button-img zone-control__button-back"
                         ngSrc="/assets/img/zone_icons/back.svg"
                         data-testid="back-button"
                         width="40" height="40" alt="" />
                </button>
                <button class="control__button bg-ok"
                    (click)="zones.goToState('zone_time_limitation')">
                    <img class="control__button-img"
                        data-testid="time-limit-button"
                        ngSrc="/assets/img/zone_icons/time_left.svg"
                        width="40" height="40" alt="" />
                </button>
                <button class="control__button bg-ok bg-ok--accept"
                    [ngClass]="{ 'not-allowed opacity-03': initZoneSetTemperature === zones.selectedZone['mode'].setTemperature}"
                        [disabled]="initZoneSetTemperature === zones.selectedZone['mode'].setTemperature"
                        (click)="sendConstantTemp();">
                    <img class="control__button-img"
                        data-testid="send-button"
                        ngSrc="/assets/img/icons/ok.svg"
                        width="40" height="40" alt="" />
                </button>
            </div>
        </div>
    </div>
</div>
